import { CustomNode } from '../../../types';
import { changeContactFieldIcon } from '../../../icons';

const DEFAULT_ICON = changeContactFieldIcon;

export const changeContactFieldConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
